import { render } from "./PlacesDynamicTopMatter.vue?vue&type=template&id=251a3bdc&scoped=true&ts=true"
import script from "./PlacesDynamicTopMatter.vue?vue&type=script&lang=ts"
export * from "./PlacesDynamicTopMatter.vue?vue&type=script&lang=ts"

import "./PlacesDynamicTopMatter.vue?vue&type=style&index=0&id=251a3bdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251a3bdc"]])

export default __exports__